import {bg} from "./bg";
import {cs} from "./cs";
import {da} from "./da";
import {de} from "./de";
import {el} from "./el";
import {en} from "./en";
import {fr} from "./fr";
import {hu} from "./hu";
import {it} from "./it";
import {is} from "./is";
import {lt} from "./lt";
import {lv} from "./lv";
import {no} from "./no";
import {nl} from "./nl";
import {ro} from "./ro";
import {ru} from "./ru";
import {sk} from "./sk";
import {sv} from "./sv";
import {sr} from "./sr";
import {es} from "./es";
import {pl} from "./pl";
import {pt} from "./pt";
import {zh} from "./zh";

import * as languages from "../constants/languages";
import * as modelHelper from "../helpers/modelHelper";

import Language from "../models/utils/Language";

export const getSupportedLanguages = () => {
    let langs = [];
    langs.push(new Language(languages.NORWAY, "Norway", languages.NAME_NORWAY, false));
    langs.push(new Language(languages.BULGARIAN, "Bulgarian", languages.NAME_BULGARIAN, false));
    langs.push(new Language(languages.CZECH, "Czech", languages.NAME_CZECH, false));
    langs.push(new Language(languages.DANISH, "Danish", languages.NAME_DANISH, false));
    langs.push(
        new Language(languages.GERMAN, "German", languages.NAME_GERMAN, false, languages.GERMAN, [
            new Language(languages.GERMAN, "German", languages.NAME_GERMAN, false, "de"),
            new Language(languages.GERMAN_AUSTRIA, "German (Austria)", languages.NAME_GERMAN_AUSTRIA, false, "at")
        ])
    );
    langs.push(new Language(languages.GREEK, "Greek", languages.NAME_GREEK, false));
    langs.push(
        new Language(languages.ENGLISH, "English", languages.NAME_ENGLISH, false, languages.ENGLISH, [
            new Language(languages.ENGLISH_GB, "English", languages.NAME_ENGLISH, false, "en"),
            new Language(
                languages.ENGLISH_AUSTRALIA,
                "English (Australia)",
                languages.NAME_ENGLISH_AUSTRALIA,
                false,
                "au"
            ),
            new Language(languages.ENGLISH_CANADA, "English (Canada)", languages.NAME_ENGLISH_CANADA, false, "ca"),
            new Language(languages.ENGLISH_INDIA, "English (India)", languages.NAME_ENGLISH_INDIA, false, "in"),
            new Language(
                languages.ENGLISH_NEW_ZEALAND,
                "English (New Zealand)",
                languages.NAME_ENGLISH_NEW_ZEALAND,
                false,
                "nz"
            ),
            new Language(languages.ENGLISH_US, "English (USA)", languages.NAME_ENGLISH_US, false, "us"),
            new Language(
                languages.ENGLISH_SOUTH_AFRICA,
                "English (South Africa)",
                languages.NAME_ENGLISH_SOUTH_AFRICA,
                false,
                "za"
            )
        ])
    );
    langs.push(new Language(languages.SPANISH, "Spanish", languages.NAME_SPANISH, false));
    langs.push(
        new Language(languages.FRENCH, "French", languages.NAME_FRENCH, false, languages.FRENCH, [
            new Language(languages.FRENCH, "French", languages.NAME_FRENCH, false, "fr"),
            new Language(languages.FRENCH_CANADA, "French (Canada)", languages.NAME_FRENCH_CANADA, false, "ca"),
            new Language(
                languages.FRENCH_SWITZERLAND,
                "French (Switzerland)",
                languages.NAME_FRENCH_SWITZERLAND,
                false,
                "ch"
            )
        ])
    );
    langs.push(new Language(languages.ITALIAN, "Italian", languages.NAME_ITALIAN, false));
    langs.push(new Language(languages.ICELAND, "Iceland", languages.NAME_ICELAND, false));
    langs.push(new Language(languages.LATVIA, "Latvian", languages.NAME_LATVIA, false));
    langs.push(new Language(languages.LITHUANIA, "Lithuanian", languages.NAME_LITHUANIA, false));
    langs.push(new Language(languages.HUNGARIAN, "Hungarian", languages.NAME_HUNGARIAN, false));
    langs.push(
        new Language(languages.DUTCH, "Dutch", languages.NAME_DUTCH, false, languages.DUTCH, [
            new Language(languages.DUTCH, "Dutch", languages.NAME_DUTCH, false, "nl"),
            new Language(languages.DUTCH_BELGIUM, "Dutch (Belgium)", languages.NAME_DUTCH_BELGIUM, false, "be")
        ])
    );
    langs.push(new Language(languages.POLISH, "Polish", languages.NAME_POLISH, false));
    langs.push(
        new Language(languages.PORTUGUESE, "Portuguese", languages.NAME_PORTUGUESE, false, languages.PORTUGUESE, [
            new Language(languages.PORTUGUESE, "Portuguese", languages.NAME_PORTUGUESE, false, "pt"),
            new Language(
                languages.PORTUGUESE_BRASIL,
                "Portuguese (Brasil)",
                languages.NAME_PORTUGUESE_BRASIL,
                false,
                "br"
            )
        ])
    );
    langs.push(new Language(languages.ROMANIAN, "Romanian", languages.NAME_ROMANIAN, false));
    langs.push(new Language(languages.RUSSIAN, "Russian", languages.NAME_RUSSIAN, false));
    langs.push(new Language(languages.SLOVAK, "Slovak", languages.NAME_SLOVAK, false));
    langs.push(
        new Language(languages.SERBIAN, "Serbian", languages.NAME_SERBIAN, false, languages.SERBIAN, [
            new Language(languages.SERBIAN, "Serbian", languages.NAME_SERBIAN, false, "sr"),
            new Language(languages.SERBIAN_LATIN, "Serbian (Latin)", languages.NAME_SERBIAN_LATIN, false, "sr")
        ])
    );
    langs.push(new Language(languages.SWEDISH, "Swedish", languages.NAME_SWEDISH, false));
    langs.push(
        new Language(languages.CHINESE, "Chinese", languages.NAME_CHINESE, false, languages.CHINESE, [
            new Language(languages.CHINESE, "Chinese (China)", languages.NAME_CHINESE_CHINA, false, "zh"),
            new Language(languages.CHINESE_TAIWAN, "Chinese (Taiwan)", languages.NAME_CHINESE_TAIWAN, false, "tw")
        ])
    );

    return langs;
};

export const getDefaultTranslations = (language) => {
    switch (language) {
        case languages.BULGARIAN:
            return bg;
        case languages.DANISH:
            return da;
        case languages.CZECH:
            return cs;
        case languages.GERMAN:
        case languages.GERMAN_AUSTRIA:
            return de;
        case languages.GREEK:
            return el;
        case languages.ENGLISH:
        case languages.ENGLISH_AUSTRALIA:
        case languages.ENGLISH_CANADA:
        case languages.ENGLISH_GB:
        case languages.ENGLISH_INDIA:
        case languages.ENGLISH_NEW_ZEALAND:
        case languages.ENGLISH_US:
        case languages.ENGLISH_SOUTH_AFRICA:
            return en;
        case languages.FRENCH:
        case languages.FRENCH_CANADA:
        case languages.FRENCH_SWITZERLAND:
            return fr;
        case languages.HUNGARIAN:
            return hu;
        case languages.ITALIAN:
            return it;
        case languages.ICELAND:
            return is;
        case languages.LITHUANIA:
            return lt;
        case languages.LATVIA:
            return lv;
        case languages.NORWAY:
            return no;
        case languages.DUTCH:
        case languages.DUTCH_BELGIUM:
            return nl;
        case languages.ROMANIAN:
            return ro;
        case languages.RUSSIAN:
            return ru;
        case languages.SERBIAN:
        case languages.SERBIAN_LATIN:
            return sr;
        case languages.SLOVAK:
            return sk;
        case languages.SPANISH:
            return es;
        case languages.SWEDISH:
            return sv;
        case languages.POLISH:
            return pl;
        case languages.PORTUGUESE:
        case languages.PORTUGUESE_BRASIL:
            return pt;
        case languages.CHINESE:
        case languages.CHINESE_CHINA:
        case languages.CHINESE_TAIWAN:
            return zh;
        default:
            return modelHelper.clone(en);
    }
};
